module.exports = __webpack_public_path__ + "img/fresas.f82bb15d.png";